import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { APIStatus } from "@application/common/enums/api-status";
import { validatePublicPasswordAsync } from "@application/features/Event/EventThunk";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import { PButton } from "@ui/components/buttons/PButton";
import { HInput } from "@ui/components/inputs/HInput";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AuthWrapper from "./AuthWrapper";
import { ArrowRightIcon } from "@ui/icons/CustomIcons";
export const ContentBox = styled(Box)(({ theme }) => ({
    width: "100%",
    textAlign: "left",
    borderRadius: "16px",
    border: "1px solid #00244D33",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 40px 56px 0px #00000014, 0px 16px 40px 0px #0000000F, 0px 4px 8px 0px #0000000A",
    [theme.breakpoints.down("sm")]: {
        padding: "32px 16px 32px 16px",
    },
    [theme.breakpoints.down("xs")]: {
        padding: "16px 8px 16px 8px",
    },
}));
export const Login = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const { status } = useAppSelector((state) => state.event);
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const isBelow1024 = useMediaQuery(theme.breakpoints.down(1025));
    const { control, handleSubmit, formState: { errors }, setError, trigger, } = useForm({
        defaultValues: {
            password: "",
        },
    });
    const onSubmit = async (data) => {
        if (!data.password.trim()) {
            setError("password", {
                type: "manual",
                message: t("login.incorrectPassword"),
            });
            return;
        }
        try {
            let response = await dispatch(validatePublicPasswordAsync({
                publicPassword: data.password,
            })).unwrap();
            if (response.isSuccess && response.data) {
                navigate("/event/register", {
                    state: { eventData: response.data },
                    replace: true,
                });
            }
            else {
                setError("password", {
                    type: "manual",
                    message: "login.invalidPassword",
                });
            }
        }
        catch (error) {
            setError("password", {
                type: "manual",
                message: "login.loginFailed",
            });
        }
    };
    return (_jsx(Box, { className: "login-container", sx: {
            ".featured-image-wrapper": {
                [theme.breakpoints.up("md")]: {
                    bottom: 120,
                },
                ".featured-image-container": {
                    gap: 4.08,
                },
                ".divider": {
                    width: 2.4,
                },
            },
            '.content-box-container': {
                [theme.breakpoints.between(601, 1153)]: {
                    paddingTop: '45px',
                }
            }
        }, children: _jsx(AuthWrapper, { children: _jsxs(ContentBox, { maxWidth: isSmallScreen ? "100%" : "590px", sx: {
                    scrollbarWidth: "none", // For Firefox
                    msOverflowStyle: "none", // For IE and Edge
                    "&::-webkit-scrollbar": {
                        display: "none",
                    },
                }, padding: isSmallScreen ? "16px 24px 16px 24px" : "48px 24px 48px 24px", children: [_jsx(Typography, { variant: "h4", sx: { fontFamily: "SuisseIntl" }, fontWeight: 500, color: "#00244D", children: t("eventlogin.loginToRegister") }), _jsx(Typography, { sx: { fontFamily: "SuisseIntl", fontSize: { xs: 12, md: 16 } }, color: "#00244D", mb: 1, mt: 1, children: t("eventlogin.enterCode") }), _jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [_jsx(HInput, { control: control, name: "password", label: t("formFields.password"), error: errors.password?.message, rules: {
                                    required: "login.incorrectPassword",
                                }, type: "password" }), _jsx(PButton, { size: "large", color: "ePrimary", fullWidth: true, type: "submit", mt: isSmallScreen ? 1 : 2, disabled: status === APIStatus.PENDING, endIcon: _jsx(ArrowRightIcon, {}), children: t("eventlogin.loginContinue") })] })] }) }) }));
};
